// this will work with the following URL template:
// <protocol>://<hostName>/local/....
export const getLocalFromLocation = (location: Location): string => {
  const locationParts = location.href.split('/');

  const local = locationParts[3];
  return local;
};
